import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { TCCPCommonService } from '../services/tccp-common.service';
@Directive({
  selector: '[appOutSideClick]'
})
export class OutSideClickDirective {
  constructor(private commonService: TCCPCommonService) {
  }

  @Input('appOutSideClick') componentName: string;

  @HostListener('click') onMouseEnter() {
    if ((this.commonService.isVideosComponentOpened) || (this.commonService.isResourceComponentOpened)) {
      if (this.componentName !== '') {
        //  this.commonService.hideHeaderMenus.emit(true);
      }
    }
  }

}
